"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var BootstrapElement = function (bootClassName, element) {
    if (element === void 0) { element = react_1.default.createElement("div", null); }
    return function (_a) {
        var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
        return react_1.cloneElement(element, __assign(__assign(__assign({}, element.props), props), { className: classnames_1.default(bootClassName, element.props.className, className), children: children }));
    };
};
exports.Container = BootstrapElement('container');
exports.Row = BootstrapElement('row');
exports.Col = BootstrapElement('col');
exports.Offset = BootstrapElement('col col-md-8 offset-md-2');
exports.PageHeader = BootstrapElement('position-relative bg-primary bg-md-white mb-0 clear-top pb-3');
exports.TitleMd = BootstrapElement('d-none d-md-block text-uppercase', react_1.default.createElement("h4", null));
exports.TitleXs = BootstrapElement('d-md-none text-center text-white text-uppercase', react_1.default.createElement("h4", null));
exports.Button = BootstrapElement('btn', react_1.default.createElement("button", null));
exports.default = BootstrapElement;
//# sourceMappingURL=index.js.map